import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type { NormalizedInterval } from 'date-fns'
import { hash } from 'rsvp'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export class FastPhonicsDashboardTableRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const stats = await this.makeStatsRequests('fast_phonics', statsScope, period)

    return { ...stats, scopedStudents }
  }

  makeStatsRequests = async (product: LegacyProductFp, scope: StudentsScope, period: NormalizedInterval) => {
    return hash({
      dashboardData: this.studentEvents.summarySchoolFp(product, scope, period),
    })
  }
}

export default FastPhonicsDashboardTableRoute
